/**********************************************************************
 ** PATIENT Routes                                                   **
 **********************************************************************/

(function () {
  'use strict';

  angular
    .module('home')
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    {
      // view to render patientnew and patientlist components in
      $stateProvider
        .state('patient', {
          url: '/patient',
          views: {
            main: {
              template: `
            <h3>Patienten suchen und neuen Patienten anlegen</h3>
            <form>
              <div ui-view="patientnewview"></div>
            </form>
            <h3>Patienten</h3>
            <div ui-view="patientlistview"></div>
          `
            }
          },
          onEnter: function () {
            console.log('patient state entered');
          }
        });


      // render patientnew, patientlist inside patientview
      $stateProvider
        .state('patient.patients', {
          url: '/patients',
          // the `users` input binding on the component receives
          // the `userlist` resolve value (from the state)
          // bind $transistions to gain access to $transition$ object

          resolve: {
            patientcats: function () {
              return ['Patient', 'Organisation', 'Unternehmen'];
            },
            mode: function () {
              return 'patient';
            },
            grabfocus: function () {
              return true;
            },
            redirect: function () {
              return 'patientrecord.current';
            },
            redirectnew: function () {
              return 'patientrecord.basicdata';
            },
            onSelectRecord: ['$state', function ($state) {
              return function (patient, mode) {
                $state.go('patientrecord.basicdata', {
                  client: patient,
                  clientid: patient._id,
                  mode: mode
                });
              };
            }],
            onCreate: ['$state', function ($state) {
              return function (patient, mode) {
                console.log('debug - onCreate cb with state change called: ', patient);
                $state.go('patientrecord.basicdata', {clientid: patient._id, mode: mode});
              };
            }]
          },
          views: {
            'patientnewview@patient': {
              component: 'clientsearch',
              bindings: {
                redirect: 'redirect',
                redirectnew: 'redirectnew',
                mode: 'mode',
                grabfocus: 'grabfocus'
              }
            },
            'patientlistview@patient': {
              component: 'clientlist',
              bindings: {
                mode: 'mode',
              }
            },
          },
          onEnter: function () {
            console.log('patient.patients state entered');
          }
        });

      // Patientenakte/Patientenakte
      $stateProvider.state('patientrecord', {
        url: '/patientrecord/:mode/:clientid',
        views: {
          'mm1': {
            component: 'patientheader'
          },
          'mm2': {
            templateUrl: 'patientrecordmenu.tpl.html',
            controller: ['$stateParams', function ($stateParams) {
              let vm = this;
              console.log('stateparams in patientrecord state controller: ', $stateParams);
              vm.clientid = $stateParams.clientid;
              vm.mode = $stateParams.mode;
            }],
            controllerAs: 'vm'
          },
          'lb1': {
            component: 'drugcurrent'
          },
          'lb2': {
            component: 'clientreminder',
            bindings: {
              clientid: 'patientid',
              mode: 'mode'
            }
          },
          'lb3': {
            component: 'clientlog',
            bindings: {
              clientid: 'patientid',
              mode: 'mode'
            }
          },
          'rb1': {
            component: 'todowidget'
          },
          'rb2': {
            component: 'chat'
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', '$log', function ($stateParams, $log) {
            return $stateParams.clientid;
          }],
          clientid: ['$stateParams', '$log', function ($stateParams, $log) {
            return $stateParams.clientid;
          }],
          mode: ['$stateParams', '$log', function ($stateParams, $log) {
            return $stateParams.mode;
          }]
        },
        onEnter: ['$state', function onEnter($state) {
          console.log('### left panle patientrecord state entered, params: ', $state.params);
        }]
      });


      // Patientenakte Aktuell
      $stateProvider.state('patientrecord.current', {
        url: '/current',
        views: {
          'pr1@patientrecord': {
            component: 'consultrecord',
            bindings: {
              patientid: 'patientid'
            }
          },
          'prsm1@patientrecord': {
            component: 'clientlog',
            bindings: {
              clientid: 'patientid',
              mode: 'mode'
            }
          },
          'prsm2@patientrecord': {
            component: 'clientreminder',
            bindings: {
              clientid: 'patientid',
              mode: 'mode'
            }
          }
        },
        params: {
          clientid: '',
          mode: 'mode'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }],
          clientid: ['$stateParams', '$log', function ($stateParams, $log) {
            return $stateParams.clientid;
          }],
          mode: ['$stateParams', '$log', function ($stateParams, $log) {
            return $stateParams.mode;
        }]},
        onEnter: ['$state', function onEnter($state) {
          console.log('### patientrecord.current state entered, params: ', $state.params);
        }]
      });

      // Patientenakte Historie
      $stateProvider.state('patientrecord.history', {
        url: '/history',
        views: {
          'pr1@patientrecord': {
            component: 'consultlist',
            bindings: {
              patientid: 'patientid'
            }
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }]
        },
        onEnter: function onEnter() {
          console.log('patientrecord.history state entered');
        }
      });

      // Patientenakte Medikamente
      $stateProvider.state('patientrecord.drugs', {
        url: '/drugs',
        views: {
          'pr1@patientrecord': {
            component: 'drugcurrent',
            bindings: {
              patientid: 'patientid'
            }
          },
          /*'pr2@patientrecord': {
            component: 'druginteraction',
            bindings: {
              patientid: 'patientid'
            }
          },*/
          'pr3@patientrecord': {
            component: 'drugprescription',
            bindings: {
              patientid: 'patientid'
            }
          },
          'pr4@patientrecord': {
            component: 'drugforeign',
            bindings: {
              patientid: 'patientid'
            }
          },
          'pr5@patientrecord': {
            component: 'druglist',
            bindings: {
              patientid: 'patientid'
            }
          },
          'pr6@patientrecord': {
            component: 'drughistory',
            bindings: {
              patientid: 'patientid'
            }
          },
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }]
        },
        onEnter: function onEnter() {
          console.log('patientrecord.drugs state entered');
        }
      });


      // Patientenakte Untersuchungen
      $stateProvider.state('patientrecord.examinations', {
        url: '/examinations',
        views: {
          'pr1@patientrecord': {
            component: 'examlist',
            bindings: {
              patientid: 'patientid'
            }
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }]
        },
        onEnter: function onEnter() {
          console.log('patientrecord.examinations state entered');
        }
      });

      // Patientenakte Dokumente
      $stateProvider.state('patientrecord.documents', {
        url: '/documents',
        views: {
          'pr1@patientrecord': {
            template: `<h3>Dateien für Patienten hinaufladen</h3>`
          },
          'pr2@patientrecord': {
            component: 'patfileupload',
            bindings: {
              patientid: 'patientid'
            }
          },
          'pr3@patientrecord': {
            template: `<h3>Dateien, Bilder, Scans</h3>`
          },
          'pr4@patientrecord': {
            component: 'complexfilelist',
            bindings: {
              key: 'idname',
              value: 'patientid'
            }
          },
          'pr5@patientrecord': {
            template: `<h3>Lokal erstellte Dokumente</h3>`
          },
          'pr6@patientrecord': {
            component: 'complexdocumentlist',
            bindings: {
              key: 'idname',
              value: 'patientid'
            }
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }],
          idname: function () {
            return 'patientid';
          },
        },
        onEnter: function onEnter() {
          console.log('patientrecord.examinations state entered');
        }
      });

      // Patientenakte Tracker
      $stateProvider.state('patientrecord.trackers', {
        url: '/trackers',
        views: {
          'pr1@patientrecord': {
            component: 'trackervaluenew',
            bindings: {
              clientid: 'patientid'
            }
          }
        },
        params: {
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          patientid: ['$stateParams', function ($stateParams) {
            return $stateParams.clientid;
          }]
        },
        onEnter: function onEnter() {
          console.log('patientrecord.examinations state entered');
        }
      });


      // Patientenakte Stammdaten
      $stateProvider.state('patientrecord.basicdata', {
        url: '/basicdata',
        views: {
          'pr1@patientrecord': {
            component: 'clienteditor',
            bindings: {
              client: 'patient',
              clientid: 'patientid',
              mode: 'mode',
              patientcategories: 'patientcategories'
            }
          }
        },
        params: {
          client: {},
          clientid: '',
          mode: 'patient'
        },
        resolve: {
          mode: ['$stateParams', function ($stateParams) {
            return $stateParams.mode;
          }],
          patient: ['ClientHelper', '$stateParams', function (ClientHelper, $stateParams) {
            console.log(' ### patientrecord.basicdata log inside resolve: ', $stateParams);
            if (angular.isDefined($stateParams.client) && $stateParams.client.hasOwnProperty('_id')) {
              console.log('patientrecord.basicdata log inside resolve, recycling client: ', $stateParams.client);
              return $stateParams.client;
            }
          }],
          patientid: ['ClientHelper', '$stateParams', function (ClientHelper, $stateParams) {
            console.log('patientrecord.basicdata log inside resolve clientid: ', $stateParams.clientid);
            return $stateParams.clientid;
          }],

          patientcategories: function () {
            return ['Patient', 'Organisation', 'Unternehmen'];
          }
        },
        onEnter: function onEnter() {
          console.log('patientrecord.basicdata state entered');
        }
      });


      // show modal for patient searching
      $stateProvider.state('patientsearch', {
        url: 'patientsearch',
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
          $uibModal.open({
            template: '<div class="modalspacer"><form class="form-vertical"><clientsearch mode="patient" redirect="patientrecord"></clientsearch></form></div>'
          });
        }]
      });


      // show modal for searching and entering new patients
      $stateProvider.state('newpatient', {
        url: '/newpatient',
        onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {

          console.log('onenter newpatient state: ', $state);
          $uibModal.open({
            template: '<div class="modalspacer"><patientnewsearch dialog="miCtrl.$uibModalInstance"></patientnewsearch></div>',
            controllerAs: 'miCtrl',
            controller: ['$uibModalInstance', function ($uibModalInstance) {
              let vmi = this;
              vmi.$uibModalInstance = $uibModalInstance;
            }],
            size: 'lg'
          });
        }]
      });

    }
// klammerfriedhof
  }
}());